export class DadosRegulamentosEmprestimos {

    static dadosRegulamentoEmprestimos: DadosRegulamentosEmprestimos[]= [
        { id: 'pcd', descricao: 'Vigência a partir de 23 de Janeiro de 2023', caminho: 'Regulamento_Emprestimo_PCD_23_1_2023.pdf' },
        { id: 'pbdc', descricao: 'Vigência a partir de 23 de Janeiro de 2023', caminho: 'Regulamento_Emprestimo_PBDC_23_1_2023.pdf' },
        { id: 'pbb', descricao: 'Vigência a partir de 23 de Janeiro de 2023', caminho: 'Regulamento_Emprestimo_PBB_23_1_2023.pdf' },
        { id: 'pcd', descricao: 'Vigência a partir de 3 de Maio de 2021', caminho: 'Regulamento_Emprestimo_PCD_03_05_2021.pdf' },
        { id: 'pbdc', descricao: 'Vigência a partir de 3 de Maio de 2021', caminho: 'Regulamento_Emprestimo_PBDC_03_05_2021.pdf' },
        { id: 'pbb', descricao: 'Vigência a partir de 3 de Maio de 2021', caminho: 'Regulamento_Emprestimo_PBB_03_05_2021.pdf' },
        { id: 'pbb', descricao: 'Vigência a partir de 4 de Maio de 2020', caminho: 'Regulamento_Emprestimo_PBB_4-5-2020.pdf' },
        { id: 'pbb', descricao: 'Vigência a partir de 2 de Janeiro de 2019', caminho: 'regulamento_emprestimo_PBB_2019.pdf' },
        { id: 'pbb', descricao: 'Vigência a partir de 1ª de Maio de 2011', caminho: 'regulamento_emprestimo.pdf' },
        { id: 'pbdc', descricao: 'Vigência a partir de 4 de Maio de 2020', caminho: 'Regulamento_Emprestimo_PBDC_4-5-2020.pdf' },
        { id: 'pbdc', descricao: 'Vigência a partir de 2 de Janeiro de 2019', caminho: 'regulamento_emprestimo_PBDC_2019.pdf' },
        { id: 'pbdc', descricao: 'Vigência a partir de 1ª de Maio de 2011', caminho: 'regulamento_emprestimo.pdf' },
        { id: 'pcd', descricao: 'Vigência a partir de 4 de Maio de 2020', caminho: 'Regulamento_Emprestimo_PCD_4-5-2020.pdf' },
        { id: 'pcd', descricao: 'Vigência a partir de 2 de Outubro de 2017', caminho: 'Regulamento_Emprestimo_-_PCD.pdf' },
    ]

    constructor(
        public id: string,
        public descricao: string,
        public caminho: string
    ) {

    }




}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-regulamentos-emprestimos/dados-regulamentos-emprestimos.ts